var TO_PRIMITIVE = require(117)('toPrimitive')
  , proto        = Date.prototype;

if(!(TO_PRIMITIVE in proto))require(40)(proto, TO_PRIMITIVE, require(26));